export default __webpack_public_path__ + "static/media/google-cloud-radio.75c02507.svg";